import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import 'assets/scss/index.scss'
import './assets/scss/styler.scss'
import App from './App'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { HelmetProvider } from 'react-helmet-async'
import ReactErrorBoundary from 'ReactErrorBoundary'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  sendDefaultPii: true
})

console.log(`[DinDin] v2026.02.22.3 | env=${process.env.REACT_APP_ENVIRONMENT} | sentry=${process.env.REACT_APP_SENTRY_DSN ? 'configured' : 'missing'}`)

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <ReactErrorBoundary>
        <ToastContainer position="top-right" autoClose={5000} />
        <App />
      </ReactErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
